import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './styles.css';

const ContactPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    rating: 0,
    source: 'contato'
  });
  const [status, setStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  useEffect(() => {
    // Processar parâmetros da URL
    const urlParams = new URLSearchParams(window.location.search);
    const produto = urlParams.get('produto');
    const usuario = urlParams.get('usuario');
    const origem = urlParams.get('origem');
    
    // Auto-preencher dados do usuário logado (localStorage)
    try {
      const userData = localStorage.getItem('userData');
      const userEmail = localStorage.getItem('userEmail');
      
      // Preencher email: prioridade URL > localStorage
      const emailToUse = usuario || (userData ? JSON.parse(userData).email : null) || userEmail || '';
      
      // Mapear produto para assunto sugerido
      let subjectSuggestion = '';
      if (produto === 'ebook-procrastinacao') {
        subjectSuggestion = 'feedback-ebook';
      } else if (produto === 'ebook-resiliencia') {
        subjectSuggestion = 'feedback-ebook2';
      }
      
      // Mapear origem para source mais descritivo
      let sourceValue = 'contato'; // default
      if (origem === 'conclusao' && produto === 'ebook-procrastinacao') {
        sourceValue = 'ebook1-conclusao';
      } else if (origem === 'pagina45' && produto === 'ebook-resiliencia') {
        sourceValue = 'ebook2-pagina45';
      } else if (origem) {
        sourceValue = origem;
      }
      
      setFormData(prev => ({
        ...prev,
        name: userData ? JSON.parse(userData).name || '' : '',
        email: emailToUse,
        subject: subjectSuggestion,
        source: sourceValue
      }));
      
    } catch (error) {
      console.log('Não foi possível carregar dados do usuário');
      
      // Se houve erro mas temos parâmetros da URL, usar eles
      if (usuario) {
        setFormData(prev => ({
          ...prev,
          email: usuario
        }));
      }
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleRatingChange = (rating) => {
    setFormData(prev => ({
      ...prev,
      rating
    }));
  };

  const handleCloseModal = () => {
    setShowSuccessModal(false);
    // Navegação inteligente: verifica se veio de outra página ou se foi acesso direto
    if (window.history.length > 1 && document.referrer && document.referrer !== window.location.href) {
      // Se há histórico e referrer, volta para página anterior
      navigate(-1);
    } else {
      // Se foi acesso direto (de app ou sem referrer), vai para homepage
      navigate('/');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.email || !formData.message) {
      setStatus('Por favor, preencha todos os campos obrigatórios.');
      return;
    }

    setIsSubmitting(true);
    setStatus('Enviando mensagem...');

    try {
      const response = await fetch('https://dropsebook.com/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();

      if (response.ok && result.success) {
        // Limpar formulário
        setFormData({
          name: formData.name,
          email: formData.email,
          subject: '',
          message: '',
          rating: 0
        });
        // Mostrar modal de sucesso
        setShowSuccessModal(true);
      } else {
        setStatus(result.message || 'Erro ao enviar mensagem. Tente novamente.');
      }
    } catch (error) {
      setStatus('Erro ao enviar mensagem. Verifique sua conexão e tente novamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const StarRating = () => {
    return (
      <div className="star-rating">
        <label>Avalie sua experiência (opcional):</label>
        <div className="stars">
          {[1, 2, 3, 4, 5].map(star => (
            <span
              key={star}
              className={`star ${star <= formData.rating ? 'filled' : ''}`}
              onClick={() => handleRatingChange(star)}
            >
              ★
            </span>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        <div className="contact-header">
          <h1>Entre em Contato</h1>
          <p>Sua opinião é muito importante para nós! Conte sobre sua experiência com nossos eBooks ou tire suas dúvidas.</p>
        </div>

        <div className="contact-content">
          <div className="contact-info">
            <h3>Por que seu feedback é importante?</h3>
            <ul>
              <li>🎯 Nos ajuda a melhorar nossos conteúdos</li>
              <li>📚 Permite criar eBooks ainda melhores</li>
              <li>💬 Facilita o suporte personalizado</li>
              <li>🚀 Direciona nossas próximas publicações</li>
            </ul>
            
            <div className="contact-stats">
              <h4>Nossa comunidade:</h4>
              <p>📖 +1000 leitores ativos</p>
              <p>⭐ 4.8/5 de satisfação média</p>
              <p>📧 Resposta em até 24h</p>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Nome Completo *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Seu nome completo"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">E-mail *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="seu@email.com"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="subject">Assunto</label>
              <select
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleInputChange}
              >
                <option value="">Selecione um assunto</option>
                <option value="feedback-ebook">Feedback sobre eBook</option>
                <option value="sugestao">Sugestão de melhoria</option>
                <option value="duvida-tecnica">Dúvida técnica</option>
                <option value="novo-conteudo">Sugestão de novo conteúdo</option>
                <option value="problema-acesso">Problema de acesso</option>
                <option value="elogio">Elogio</option>
                <option value="outro">Outro</option>
              </select>
            </div>

            <StarRating />

            <div className="form-group">
              <label htmlFor="message">Sua Mensagem *</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                placeholder="Conte-nos sobre sua experiência, dúvidas ou sugestões..."
                rows="6"
                required
              />
            </div>

            <div className="form-actions">
              <button 
                type="submit" 
                className="submit-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Enviando...' : 'Enviar Mensagem'}
              </button>
            </div>

            {status && (
              <div className={`status-message ${status.includes('sucesso') ? 'success' : 'error'}`}>
                {status}
              </div>
            )}
          </form>
        </div>

        <div className="contact-footer">
          <p>🔒 Seus dados estão seguros conosco - não compartilhamos informações pessoais.</p>
          <p>📧 E-mail direto: <a href="mailto:feedback@dropsebook.com">feedback@dropsebook.com</a></p>
        </div>
      </div>

      {/* Modal de Sucesso */}
      {showSuccessModal && (
        <div className="success-modal-overlay">
          <div className="success-modal">
            <div className="success-modal-header">
              <div className="success-icon">✅</div>
              <h2>Obrigado pelo seu Feedback!</h2>
            </div>
            
            <div className="success-modal-content">
              <p>🎉 <strong>Sua mensagem foi enviada com sucesso!</strong></p>
              
              <div className="success-details">
                <div className="success-item">
                  <span className="success-emoji">📧</span>
                  <span>Você receberá uma confirmação por email</span>
                </div>
                <div className="success-item">
                  <span className="success-emoji">⏰</span>
                  <span>Responderemos em até 24 horas</span>
                </div>
                <div className="success-item">
                  <span className="success-emoji">💙</span>
                  <span>Seu feedback é muito valioso para nós!</span>
                </div>
              </div>

              <div className="success-message-box">
                <p>
                  <strong>O que acontece agora?</strong><br/>
                  Nossa equipe analisará seu feedback cuidadosamente e entrará em contato 
                  através do email cadastrado. Continuamos trabalhando para melhorar 
                  nossos eBooks e sua experiência!
                </p>
              </div>
            </div>

            <div className="success-modal-actions">
              <button 
                onClick={handleCloseModal}
                className="success-modal-btn"
              >
                <span>✨ Perfeito, Obrigado!</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactPage;